/** custom theme atom: 유저가 front페이지의 적용할 custom theme */
import { atom } from 'recoil';

import { UserCustomTheme } from '@shared/types';

export const THEME = UserCustomTheme.Preed;

/** custom theme atom: 유저가 front페이지의 적용할 custom theme */
export const customThemeAtom = atom<UserCustomTheme>({
  key: 'customThemeAtom',
  default: THEME,
  //* 브랜드 전용 빌드는 테마 고정 — 로그인(TokenProvider)이 info.theme 없는 계정(storeGuest 등)에서
  //* Default로 덮어써 포털 모달(결제창 등)만 살구색으로 바뀌던 문제 방지
  effects: [
    ({ setSelf, onSet }) => {
      onSet((next) => {
        if (next !== THEME) setSelf(THEME);
      });
    },
  ],
});
